define([
    'text!./templates/basler-edit-coverage.html',
    'angular',
], (editCoverageTemplate, angular) => {
    /**
     * Directive will open a Popup with a gw-editable-coverage (which allows changing coverage terms)
     * for the given coverage on clicking the element it's applied to.
     *
     * However, the popup will operate on a _copy_ of the given coverage in order to
     * allow cancelling all edits easily by throwing away the new coverage copy
     * (This is also true for the setCoverage() callbacks for the onChangeCoverage and onToggleCoverage params
     * - the given coverage is copied ant then set as the modal model).
     *
     * If you wish to apply the changes, use the on-change-coverage callback to replace
     * your original coverage with the new copy.
     *
     * As an example, the MFPQuoteDetails page (which displays the 3 offerings) calls
     * the CustomQuoteService with edited coverage copy of this page. If the call
     * is successful, the model coverages is updated. If the call fails (e.g. if the
     * server does not allow certain combinations of CovTerm options), the changes
     * are thrown away / not copied to the actual model.
     */
    const directive = function (ModalService) {
        return {
            restrict: 'A',
            scope: {
                coverage: '=baslerEditCoverage',
                onChangeCoverage: '&',
                showToggleCoverage: '=',
                onToggleCoverage: '&',
            },
            link: linkFunction,
        };

        function linkFunction(scope, element) {
            element.on('click', openModal);

            function onCovChange(modalScope) {
                if (scope.onChangeCoverage) {
                    scope.onChangeCoverage({
                        coverage: modalScope.coverage,
                        setCoverage: (coverage) => {
                            modalScope.coverage = angular.copy(coverage);
                        },
                        setLoading: (loading) => {
                            modalScope.loading = loading;
                        },
                        closeModal: () => {
                            modalScope.$close();
                        },
                    });
                }
            }

            function onToggleCoverage(modalScope) {
                if (scope.onToggleCoverage) {
                    scope.onToggleCoverage({
                        coverage: modalScope.coverage,
                        setCoverage: (coverage) => {
                            modalScope.coverage = angular.copy(coverage);
                        },
                        setLoading: (loading) => {
                            modalScope.loading = loading;
                        },
                        closeModal: function () {
                            modalScope.$close();
                        },
                    });
                }
            }

            function openModal() {
                const coverageCopy = angular.copy(scope.coverage);
                const data = {
                    coverage: coverageCopy,
                    showToggleCoverage: scope.showToggleCoverage,
                    loading: false,
                };
                const functions = {
                    onCovChange: onCovChange,
                    onToggleCoverage: onToggleCoverage,
                };
                ModalService.showSimpleDialog(editCoverageTemplate, data, functions);
            }
        }
    };
    directive.$inject = ['ModalService'];
    return directive;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/directives/BaslerEditCoverage.js